import { useMemo } from "react";
import { AvatarGroupItem, AvatarGroup } from "@fluentui/react-components";
import FluentUiIcon from "../../assets/fluent-ui-icon";
import PropTypes from "prop-types";

const TaskMemberAvatarPill = ({ user, permission = "", size=32 }) => {
  const isGroup = user?.IsGroup;
  const isOwner = permission === "owner";

  // Archived/moved assignees (TAD-5898) keep their identity color — the chip
  // container's .pill-archived opacity softens the whole pill, matching the
  // Sync Member Permissions treatment (TAD-5797).
  const color = useMemo(() => {
    if (isOwner && isGroup) return "dark-red";
    if (isOwner) return "brand";
    if (isGroup)return "red";
    return "blue";
  }, [isOwner, isGroup]);

  const getBadge = () => {
    if (!isGroup) return null;
    return {
      icon: (
        <FluentUiIcon
          name="PeopleFilled"
          color={isOwner ? "#370B10" : "#CD9EA5"}
          size={8}
        />
      ),
    };
  };

  return (
    <AvatarGroup>
        <AvatarGroupItem
        size={size}
        name={user?.Name}
        color={color}
        className={color === "brand" ? "avatar-brand" : ""}
        badge={getBadge()}
      />
    </AvatarGroup>
  );
};

TaskMemberAvatarPill.propTypes = {
  user: PropTypes.shape({
    IsGroup: PropTypes.bool,
    Initials: PropTypes.string,
    Name: PropTypes.string
  }),
  permission: PropTypes.oneOf(['owner', 'editor', 'viewer', 'approver']),
  size: PropTypes.number
};

TaskMemberAvatarPill.defaultProps = {
  user: null,
  permission: '',
  size: 32
};

export default TaskMemberAvatarPill;